export const ArticlesFiltersMap = {
  category: 'category',
  tag: 'tag',
  author: 'author',
};

export const ArticlesFilters = Object.values(ArticlesFiltersMap);

export const ArticlesPagination = ['page', 'limit'];
